import { Button, Checkbox, DatePicker, Form, Input, Rate, Select, TimePicker, Upload } from 'antd';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import locale from 'antd/es/date-picker/locale/fr_FR';
import { FaUserAlt } from 'react-icons/fa';
import { validateURL } from '../../../utils/function';
import useAuthRequest from '../../../services/requests.service';
import { Bounce, toast } from 'react-toastify';
import { useAppData } from '../../../hooks/useAppData';
import { useOfferReducer } from '../../../hooks/useOfferReducer';
import { PlusOutlined } from '@ant-design/icons';

const CreateOffer2 = ({ isAdmin, setDeals, setIsModalOpen, setIsLoading, page }) => {
  const { formData, updateMultipleFields, nextStep, currentDeal } = useOfferReducer();
  
  const [form] = Form.useForm();
  const [isPerma, setIsPerma] = useState(formData.isPerma || false);
  const [activeMode, setActiveMode] = useState(formData.mode || '');

  const [fileList, setFileList] = useState(formData.filePdf || []);
  const request = useAuthRequest();
  const [isNonPreciseTimeChecked, setIsNonPreciseTimeChecked] = useState(formData.isNonPreciseTimeChecked || false);
  const { data: datas } = useAppData();

  const days = datas?.days.map((filter) => ({ value: filter.id, label: filter.name }));

  useEffect(() => {
    if (currentDeal) {
      const mergedData = {
        ...formData,
        startdate: currentDeal.startdate ? dayjs(currentDeal.startdate, 'YYYY-MM-DD') : '',
        enddate: currentDeal.enddate !== '2099-12-31' ? dayjs(currentDeal.enddate, 'YYYY-MM-DD') : '',
        starttime: currentDeal.starttime ? dayjs(currentDeal.starttime, 'HH:mm') : '',
        endtime: currentDeal.endtime ? dayjs(currentDeal.endtime, 'HH:mm') : '',
      };
      updateMultipleFields(mergedData);
      setIsPerma(currentDeal.enddate === '2099-12-31' || false);
      setIsNonPreciseTimeChecked((currentDeal.starttime === '' && currentDeal.endtime === '') || false);
      setActiveMode(currentDeal.mode || '');
      setFileList(currentDeal.filePdf || []); 
      // Utiliser setTimeout pour s'assurer que le formulaire est prêt
      setTimeout(() => {
        form.setFieldsValue(mergedData);
      }, 100);
    } else {
      // Réinitialiser le formulaire pour une nouvelle offre
      form.resetFields();
      setIsPerma(false);
      setIsNonPreciseTimeChecked(false);
      setActiveMode('');
      setFileList([]);
    }
  }, [currentDeal, updateMultipleFields]);

  const handleDateChange = (date, dateString, field) => {
    const updatedFormData = {
      ...formData,
      [field]: date ? dayjs(date).format('YYYY-MM-DD') : '', // Ensure proper date format
    };
    updateMultipleFields(updatedFormData);
  };
  
  const handleTimeChange = (time, timeString, field) => {
    const updatedFormData = {
      ...formData,
      [field]: time ? dayjs(time).format('HH:mm') : '', // Ensure proper time format
    };
    updateMultipleFields(updatedFormData);
  };
  

  const handleCheckboxPermaChange = (e) => {
    setIsPerma(e.target.checked);
    const updatedFormData = {
      ...formData,
      isPerma: e.target.checked,
      startdate: e.target.checked ? '' : formData.startdate,
      enddate: e.target.checked ? '' : formData.enddate,
    };
    updateMultipleFields(updatedFormData);

    form.setFieldsValue({
      startdate: updatedFormData.startdate ? dayjs(updatedFormData.startdate, 'YYYY-MM-DD') : '',
      enddate: updatedFormData.enddate ? dayjs(updatedFormData.enddate, 'YYYY-MM-DD') : '',
    });
  };

  const handleCheckboxTimeChange = (e) => {
    setIsNonPreciseTimeChecked(e.target.checked);
    const updatedFormData = {
      ...formData,
      isNonPreciseTimeChecked: e.target.checked,
      starttime: e.target.checked ? '' : formData.starttime,
      endtime: e.target.checked ? '' : formData.endtime,
    };
    updateMultipleFields(updatedFormData);

    form.setFieldsValue({
      starttime: updatedFormData.starttime ? dayjs(updatedFormData.starttime, 'HH:mm') : '',
      endtime: updatedFormData.endtime ? dayjs(updatedFormData.endtime, 'HH:mm') : '',
    });
  };

  const handleClick = (choice) => {
    setActiveMode(choice);
    updateMultipleFields({ mode: choice });
  };

  const getDeals = async () => {
    let res = await request.getDataAPI(isAdmin?`dealsAll`:`/dealsByCompany/${page._id}`)
    setDeals(res)
    console.log(res)
  }

  const onFileChange = ({ file, fileList: newFileList }) => {
    if (newFileList.length === 0) {
      setFileList([]);
      updateMultipleFields({ filePdf: [] });
    } else {
      setFileList([file]);
      updateMultipleFields({ filePdf: [file] });
    }
  };

  const imageUpload = async (images) => {
    console.log("image upload");
    let imgArr = [];

    for (const item of images) {
        if(item.url)return;
        const formDataS3 = new FormData();
        formDataS3.append("image", item.originFileObj);

        console.log(JSON.stringify(formDataS3))
        try {
            const resS3 = await request.postDataAPIWithoutToken('uploadImage', formDataS3);
            console.log(resS3)
            imgArr.push({ url: resS3.uploadLocation });
        } catch (error) {
            console.error("Image upload failed:", error);
        }
    }

    return imgArr;
};

const pdfUpload = async (pdfFiles) => {
    console.log("PDF upload");
    console.log(pdfFiles)
    let pdfArr = [];

    for(const item of pdfFiles){
      if(item.url)return;

        const formDataS3 = new FormData();    
        // Directly append the PDF file to formData
        formDataS3.append("file", item, item.name);
        
        // Here, adjust the parameters as necessary for your backend requirements
        formDataS3.append("upload_preset", "bb5qshs3"); // Adjust or remove if not needed
        formDataS3.append("cloud_name", "behandy"); // Adjust or remove if not needed

        console.log(formDataS3)
        // Replace 'uploadFile' with your actual backend endpoint for file uploads
        const resS3 = await request.postDataAPIWithoutToken('uploadFile', formDataS3);
        console.log(resS3)
        // Ensure the response handling matches your backend's response structure
        pdfArr.push({url: resS3.uploadLocation});
    }

    return pdfArr;
}

  const onFinish = async () => {
    const formattedData = {
      ...formData,
      startdate: formData.startdate ? dayjs(formData.startdate).format('YYYY-MM-DD') : '',
      enddate: formData.enddate ? dayjs(formData.enddate).format('YYYY-MM-DD') : '2099-12-31',
      starttime: formData.starttime ? dayjs(formData.starttime).format('HH:mm') : '',
      endtime: formData.endtime ? dayjs(formData.endtime).format('HH:mm') : '',
    };
  
    if (!currentDeal) {
      nextStep();
    } else {
      setIsLoading(true)
      if (formData.images && formData.images.length > 0) {
        let media = await imageUpload(formData.images)
        //check that media[0].url exists
        if (Array.isArray(media) && media.length > 0 && media[0].url) {
          console.log(media);
          formattedData.images = media; // Assign the media array if valid
        }
      }

      if (formData.filePdf && formData.filePdf.length > 0) {
          let media = await pdfUpload(formData.filePdf)
          if (Array.isArray(media) && media.length > 0 && media[0].url) {
            console.log(media);
            formattedData.filePdf = media; // Assign the media array if valid
          }
      }

      try {
        let res = await request.patchDataAPI(`/deal/${currentDeal._id}`, formattedData);
        setIsModalOpen(false);
        getDeals();
        toast.success("Offre modifiée!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      } catch (e) {
        setIsLoading(false);
        toast.error(e.msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
      setIsLoading(false);
    }
  };

  return (
    <div className='flex flex-col w-full h-full'>
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        onValuesChange={(changedValues, allValues) => updateMultipleFields(allValues)}
        className="space-y-6"
        style={{ width: '100%' }}
      >
        <Form.Item
          label="Période de validité"
          style={{ marginBottom: '24px' }}
        >
          <Form.Item
            name="startdate"
            rules={[{ required: !isPerma, message: 'Entrez une date de début!' }]}
            style={{ display: 'inline-block', marginBottom: '0px', width: 'calc(50% - 8px)' }}
          >
            <DatePicker
              placeholder="Début"
              style={{ width: '100%' }}
              size="large"
              locale={locale}
              format="YYYY-MM-DD"
              onChange={(date, dateString) => handleDateChange(date, dateString, 'startdate')}
            />
          </Form.Item>
          <Form.Item
            name="enddate"
            rules={[{ required: !isPerma, message: 'Entrez une date de fin!' }]}
            style={{ display: 'inline-block', marginBottom: '0px', width: 'calc(50% - 8px)', margin: '0 8px' }}
          >
            <DatePicker
              placeholder="Fin"
              size="large"
              style={{ width: '100%' }}
              locale={locale}
              format="YYYY-MM-DD"
              onChange={(date, dateString) => handleDateChange(date, dateString, 'enddate')}
            />
          </Form.Item>

          <Checkbox onChange={handleCheckboxPermaChange} checked={isPerma}>
            Promo permanente (jusqu'à sa suppression)
          </Checkbox>
        </Form.Item>

        <Form.Item label="Jours de validité" name="date" hasFeedback>
          <Select
            mode="multiple"
            allowClear
            style={{ width: '100%' }}
            placeholder="Choississez les jours"
            options={days}
            size="large"
            dropdownStyle={{ zIndex: '100000' }}
          />
        </Form.Item>

        <Form.Item
          label="Horaire de validité"
          style={{ marginBottom: '24px' }}
        >
          <Form.Item
            name="starttime"
            rules={[{ required: !isNonPreciseTimeChecked, message: 'Entrez une horaire de début!' }]}
            style={{ display: 'inline-block', marginBottom: '0px', width: 'calc(50% - 8px)' }}
          >
            <TimePicker
              format={'HH:mm'}
              placeholder="Début"
              locale={locale}
              style={{ width: '100%' }}
              size="large"
              onChange={(time, timeString) => handleTimeChange(time, timeString, 'starttime')}
            />
          </Form.Item>
          <Form.Item
            name="endtime"
            rules={[{ required: !isNonPreciseTimeChecked, message: 'Entrez une horaire de fin!' }]}
            style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
          >
            <TimePicker
              format={'HH:mm'}
              placeholder="Fin"
              locale={locale}
              style={{ width: '100%' }}
              size="large"
              onChange={(time, timeString) => handleTimeChange(time, timeString, 'endtime')}
            />
          </Form.Item>
          <Checkbox onChange={handleCheckboxTimeChange} checked={isNonPreciseTimeChecked}>
            Non précisé
          </Checkbox>
        </Form.Item>

        <Form.Item
          label="Nombre de personnes bénéficiant de l'offre (salarié inclus)"
          name="amountPersons"
          hasFeedback
        >
          <div className="rate">
            <Rate
              character={<FaUserAlt />}
              count={8}
              style={{ fontSize: 20, color: 'var(--color-accent)' }}
              onChange={(value) => updateMultipleFields({ amountPersons: value })}
              value={formData.amountPersons || 0}
            />
          </div>
        </Form.Item>

        <Form.Item
          label="Site internet"
          placeholder="https://votresite.com"
          hasFeedback
          name="website"
          rules={[
            {
              validator: validateURL,
              message: 'Entrez une URL valide!',
            },
          ]}
        >
          <Input size="large" maxLength={500} />
        </Form.Item>

        <Form.Item
          label="Comment utiliser la promo (1 case max)"
          required={true}
          rules={[
            {
              validator: (_, value) =>
                activeMode ? Promise.resolve() : Promise.reject(new Error('Veuillez choisir une option!')),
            },
          ]}
        >
          <div className="flex flex-col gap-2">
            <div
              className={`px-3 py-3 rounded-md text-center  font-semibold hover:cursor-pointer ${
                activeMode === 'noreservation' ? 'bg-royalblue-500 hover:bg-royalblue-400 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-800'
              }`}
              onClick={() => handleClick('noreservation')}
            >
              Pas de réservation nécessaire
            </div>

            <div
              className={`px-3 py-3 rounded-md text-center font-semibold hover:cursor-pointer ${
                activeMode === 'phone' ? 'bg-royalblue-500 hover:bg-royalblue-400 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-800'
              }`}
              onClick={() => handleClick('phone')}
            >
              Réservation par téléphone
            </div>
            {activeMode === 'phone' && (
              <Form.Item
                label="Numéro de téléphone"
                name="modeInfos"
                rules={[
                  {
                    required: true,
                    message: 'Entrez votre numéro de téléphone!',
                  },
                ]}
              >
                <Input size="large" />
              </Form.Item>
            )}

            <div
              className={`px-3 py-3 rounded-md text-center font-semibold hover:cursor-pointer ${
                activeMode === 'email' ? 'bg-royalblue-500 hover:bg-royalblue-400 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-800'
              }`}
              onClick={() => handleClick('email')}
            >
              Réservation par email
            </div>
            {activeMode === 'email' && (
              <Form.Item
                label="Email"
                name="modeInfos"
                rules={[
                  {
                    required: true,
                    message: 'Entrez votre email!',
                  },
                  {
                    max: 140,
                    message: "L'email ne peut pas dépasser 140 caractères!",
                  },
                ]}
              >
                <Input size="large" maxLength={140} />
              </Form.Item>
            )}

            <div
              className={`px-3 py-3 rounded-md text-center font-semibold hover:cursor-pointer ${
                activeMode === 'code' ? 'bg-royalblue-500 hover:bg-royalblue-400 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-800'
              }`}
              onClick={() => handleClick('code')}
            >
              Code promo
            </div>
            {activeMode === 'code' && (
              <Form.Item
                label="Code promo"
                name="modeInfos"
                rules={[
                  {
                    required: true,
                    message: 'Entrez votre code promo!',
                  },
                  {
                    max: 140,
                    message: 'Le code promo ne peut pas dépasser 140 caractères!',
                  },
                ]}
              >
                <Input size="large" maxLength={140} />
              </Form.Item>
            )}
          </div>
        </Form.Item>

        <Form.Item
          label="Ajouter un fichier PDF"
          name="filePdf"
        >
          <Upload
            beforeUpload={() => false}
            onChange={onFileChange}
            multiple={false}
            fileList={fileList}
            maxCount={1}
          >
            <Button icon={<PlusOutlined />}>Ajouter un PDF</Button>
          </Upload>
        </Form.Item>

        <div className="flex justify-between space-x-4 pt-6">
          <Button size="large" onClick={() => window.history.back()}>
            Précédent
          </Button>
          <Button type="primary" htmlType="submit" size="large">
            {currentDeal ? 'Modifier' : 'Suivant'}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default CreateOffer2;
